import { render, staticRenderFns } from "./ProctoredTest.vue?vue&type=template&id=473e4444&"
import script from "./ProctoredTest.vue?vue&type=script&lang=js&"
export * from "./ProctoredTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../aristotle-website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports